<template>
    <div :style="[elementStyles, basicContentStyles]">
            <div v-bind:style="primary_styles" v-html="weekday"></div>
            <div v-bind:style="secondary_styles"> {{ datestring }} </div>
    </div>
</template>

<script>
    export default {
        props: {
            /** @type {PublishElementDataCommon | PublishElementDataDay} */
            data: Object,
            frame: Object,
            width: Number,
            height: Number,
            basicContentStyles: Object
        },
        data: function () {
            return {
                weekday: '',
                month: '',
                day: '',
                sup: '',
                datestring: '',
            }
        },
        computed: {
            elementStyles: function () {
                let opacity = 1;
                if (!isNaN(this.data.transparency)) {
                    opacity -= this.data.transparency/100;
                }
                // 0.999: such that border when selected is visualized correctly.
                opacity = Math.min(opacity, 0.999);

                return {
                    opacity: opacity,
                }
            },
            primary_styles: function () {
                let fontsize = 30;
                let fontfamily = 'Arial';

                if (typeof this.data.text_size !== 'undefined' && this.data.text_size !== null && this.data.text_size !== '') {
                    fontsize = this.data.text_size;
                }

                if (typeof this.data.text_family !== 'undefined' && this.data.text_family !== null && this.data.text_family.length > 0) {
                    fontfamily = this.data.text_family;
                }

                fontsize = parseInt(fontsize) * this.frame.ratio;

                return {
                    fontSize: fontsize + 'px',
                    fontFamily: '"' + fontfamily + '"',
                    textDecoration: this.textDecoration,
                    fontStyle: this.fontStyle,
                    fontWeight: this.fontWeight,
                    color: this.data.primary_color,
                    lineHeight: 'normal'
                }
            },
            secondary_styles: function () {
                let fontfamily = 'Arial';

                if (typeof this.data.text_family !== 'undefined' && this.data.text_family !== null && this.data.text_family.length > 0) {
                    fontfamily = this.data.text_family;
                }

                return {
                    fontSize: this.sub_size,
                    fontFamily: '"' + fontfamily + '"',
                    textDecoration: this.textDecoration,
                    fontStyle: this.fontStyle,
                    fontWeight: this.fontWeight,
                    color: this.data.secondary_color,
                    float: 'left',
                    marginRight: '2px',
                    lineHeight: 'normal'
                }
            },
            sup_styles: function () {
                let fontfamily = 'Arial';

                if (typeof this.data.text_family !== 'undefined' && this.data.text_family !== null && this.data.text_family.length > 0) {
                    fontfamily = this.data.text_family;
                }

                return {
                    fontSize: this.sub_size,
                    fontFamily: '"' + fontfamily + '"',
                    textDecoration: this.textDecoration,
                    fontStyle: this.fontStyle,
                    fontWeight: this.fontWeight,
                    color: this.data.secondary_color,
                    lineHeight: 'normal'
                }
            },
            sub_size: function () {
                let fontsize = 30;

                if (typeof this.data.text_size !== 'undefined' && this.data.text_size !== null && this.data.text_size !== '') {
                    fontsize = this.data.text_size;
                }

                fontsize = parseInt(fontsize) * this.frame.ratio;

                return Math.ceil(fontsize * 0.7) + 'px';
            },
            textDecoration: function () {
                if (this.data.text_decoration === 'underline') {
                    return 'underline';
                }

                return 'none';
            },
            fontStyle: function () {
                if (this.data.text_style === 'italic') {
                    return 'italic';
                }

                return 'normal';
            },
            fontWeight: function () {
                if (this.data.text_weight === 'bold') {
                    return 'bold';
                }

                return 'normal';
            }
        },
        methods: {
            updateDay: function () {
                let now = new Date();
                let day = now.getDate();

                this.day = day;
                this.month = now.toLocaleString(this.data.language, {month: 'long'});
                this.weekday = now.toLocaleString(this.data.language, {weekday: 'long'});
                switch (day) {
                    case 1:
                        this.sup = 'st';
                        break;
                    case 2:
                        this.sup = 'nd';
                        break;
                    case 3:
                        this.sup = 'rd';
                        break;
                    default:
                        this.sup = 'th';
                }
                if (this.data.language === 'en') {
                    this.datestring = this.month + ' ' + this.day + this.sup;
                }
                else {
                    this.datestring = now.toLocaleString(this.data.language,  {day: 'numeric', month: 'long'});
                }
            }
        },
        mounted() {
            this.updateDay();

            EaseEventBus.listen('updateDay', () => {
                this.updateDay();
            });
        }
    }
</script>
